import { AxiosResponse } from "axios";
import {
  AddJobClosureRejectCommentPayloadType,
  ApproveAndRejectRegularizePayloadType,
  GetJobClosureListPayloadType,
  GetJobClosureRatingListPaylodType,
  GetRegularizeApprovalPendingListPayloadType,
  GetScheduledUpcomingInterviewsListPayloadType,
  GetUnApprovedInvoiceCountPayloadType,
  SendApprovalStatusPayloadType,
  SingleApprovalListPayloadType,
  SingleScheduledUpcomingInterviewsDeatilsPayloadType,
} from "../commonTypes/thinksToDoTypes";
import { getData, postData } from "./apiInstance";
import { AddScheduledUpcomingInterviewsDetailsType } from "../redux/thinksToDo/thinksToDoType";
import { getCSRFToken } from "../utils/commonFunctions";

export async function getScheduledUpcomingInterviewsApi(
  data: GetScheduledUpcomingInterviewsListPayloadType
): Promise<AxiosResponse> {
  const { token, today, limit, offset } = data;
  return await getData(`/finac-crm/things-to-do/recruitment-application/list`, {
    params: {
      today,
      limit,
      offset,
    },
    headers: {
      "user-token": token,
      "Content-Type": "application/json",
    },
  });
}

export async function singleScheduledUpcomingInterviewsApi(
  data: SingleScheduledUpcomingInterviewsDeatilsPayloadType
): Promise<AxiosResponse> {
  const { token, id, type } = data;
  return await getData(`/finac-crm/hrms/recruitment-application/list/id`, {
    params: {
      id,
      type,
    },
    headers: {
      "user-token": token,
      "Content-Type": "application/json",
    },
  });
}

export async function updateRecruitmentTrackerActionApi(
  data: AddScheduledUpcomingInterviewsDetailsType
): Promise<AxiosResponse> {
  const { token, finalData } = data;
  return await postData(
    `finac-crm/things-to-do/recruitment-application/feedback/update`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function sendApprovalStatusActionApi(
  data: SendApprovalStatusPayloadType
): Promise<AxiosResponse> {
  const { token, _id, comment, status } = data;
  let finalData = {
    _id,
    comment,
    status,
  };
  return await postData(
    `finac-crm/things-to-do/approval/change/status`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getSingleApprovalListActionApi(
  data: SingleApprovalListPayloadType
): Promise<AxiosResponse> {
  const { token, approval_id } = data;
  const finalParams = {
    approval_id,
  };
  return await getData(`/finac-crm/things-to-do/approval/detail`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getJobClosureListApi(
  data: GetJobClosureListPayloadType
): Promise<AxiosResponse> {
  const { token, role, internalStatus, jobstatus, limit, type, offset } = data;
  let finalParams = {
    role,
    internal_status: internalStatus,
    job_status: jobstatus,
    limit,
    offset,
    type,
  };
  return await getData(`finac-crm/job/closure/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getJobClosureRatingListApi(
  data: GetJobClosureRatingListPaylodType
): Promise<AxiosResponse> {
  const { token, jobId } = data;
  let finalParams = {
    job_id: jobId,
  };
  return await getData(`finac-crm/job/closure/comment/list`, {
    params: {
      ...finalParams,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function addJobClosureRejectCommentApi(
  data: AddJobClosureRejectCommentPayloadType
): Promise<AxiosResponse> {
  const { token, id, comment, status, ratings } = data;
  let finalData = {
    job_id: id,
    comment,
    status,
    ratings,
  };
  return await postData(`finac-crm/job/closure/comment/add `, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getUnApprovedInvoiceCountListApi(
  data: GetUnApprovedInvoiceCountPayloadType
): Promise<AxiosResponse> {
  const { token } = data;

  return await getData(`invoice-generation/invoice/approval-pending/count`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getWeeklyApprovedUsersInvoiceEntriesCount(
  data: GetUnApprovedInvoiceCountPayloadType
): Promise<AxiosResponse> {
  const { token } = data;
  return await getData(`invoice-generation/approved/invoice/count`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getRegularizeApprovalPendingListApi(
  data: GetRegularizeApprovalPendingListPayloadType
): Promise<AxiosResponse> {
  const { token, role ,notificationId} = data;
  return await getData(`master-module/attendance/regularize/list`, {
    params: {
      role,
      status: 1,
      ...(notificationId&&{notification_id:notificationId}),
      ...(notificationId&&{is_page_seen:true})
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function approveOrRejectRegularizeApi(
  data: ApproveAndRejectRegularizePayloadType
): Promise<AxiosResponse> {
  const { token, date, userId, comment, status } = data;
  let finalData = {
    date,
    user_id: userId,
    comment,
    status,
  };
  return await postData(
    `master-module/attendance/regularize/change/status`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}
